export default __webpack_public_path__ + "static/media/greenIdea.a3d36659.svg";